import { Component } from "@angular/core";
import { Plan, PlanSummary } from "./models/plansummary";
import { CareerPlanService } from "./services/careerplan.service";


@Component({
  selector: "careerplan-list",
  templateUrl: "./careerplan-list.component.html",
  styleUrls: [],
  providers: [CareerPlanService]
})
export class CareerPlanListComponent {

  careerPlanUrl: string = "";
  planSummary: PlanSummary = {} as PlanSummary;

  plans: Plan[] = [];

  constructor(private careerPlanService: CareerPlanService) { }

  ngOnInit() {

    this.loadPlans();

  }

  loadPlans() {

    this.careerPlanService.getPlanStepSummary()
      .subscribe(res => {
        console.log('Plan Summary', res);
        this.planSummary = res;        

      });

    this.careerPlanService.getCareerPlanUrl()
      .subscribe(res => {

        this.careerPlanUrl = res;

        console.log('Career Plan URL', res);

      });
  }

}
